import { ErrorBoundary } from 'react-error-boundary';
import type { ReactNode } from 'react';

import type { ErrorInfo } from 'react';

interface GenericErrorBoundaryProps {
  children: ReactNode;
  fallback: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

export function GenericErrorBoundary({
  children,
  fallback,
  onError,
}: GenericErrorBoundaryProps) {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    console.error(
      'Component error caught by error boundary:',
      error,
      errorInfo,
    );
    onError?.(error, errorInfo);
  };

  return (
    <ErrorBoundary fallback={fallback} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
}
